module.exports = __webpack_public_path__ + "img/6.9f1645b1.jpg";